var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isLoading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-two-line"
    }
  }) : _vm.value ? _c('div', [_c('m-header', {
    attrs: {
      "title": _vm.title,
      "alerts": _vm.alerts,
      "breadCrumbs": _vm.breadCrumbs,
      "chips": _vm.chips,
      "actions": _vm.actions
    },
    on: {
      "actionClicked": function actionClicked($event) {
        return $event.exec();
      },
      "alertClicked": function alertClicked($event) {
        return $event.exec();
      }
    }
  }), _c('v-divider'), _c('m-detail-view-grid', {
    scopedSlots: _vm._u([{
      key: "details",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mt-6"
        }), _c('select-entity', {
          staticClass: "mt-5 mb-n2",
          attrs: {
            "refType": _vm.ResourceEnum.REPORT,
            "partnerId": _vm.value.partnerId,
            "label": _vm.$t('objects.repairEstimate.reportId'),
            "hint": _vm.$t('objects.repairEstimate.reportIdHint'),
            "clearable": !_vm.value.isCompleted,
            "disabled": _vm.value.isCompleted
          },
          on: {
            "input": function input($event) {
              return _vm.value.updatePartial({
                reportId: $event || null
              });
            }
          },
          model: {
            value: _vm.value.reportId,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "reportId", $$v);
            },
            expression: "value.reportId"
          }
        }), _c('shared-content-list', {
          ref: "sharedContentList",
          attrs: {
            "refId": _vm.value.id,
            "partnerId": _vm.value.partnerId,
            "title": _vm.$t('repairEstimate.shared')
          }
        })];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function fn() {
        return [_c('v-divider', {
          staticClass: "mt-6"
        }), _c('m-action-list', {
          attrs: {
            "actions": _vm.bottomActions
          },
          on: {
            "actionClicked": function actionClicked($event) {
              return $event.exec();
            }
          }
        })];
      },
      proxy: true
    }])
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "grey lighten-4"
    }
  }, [_c('v-card-text', [_c('repair-estimate-sheet', {
    ref: "repairEstimateSheet",
    attrs: {
      "estimate": _vm.value,
      "report": _vm.report,
      "hideGoToDetail": "",
      "hideSharingLink": ""
    },
    on: {
      "update:estimate": function updateEstimate($event) {
        _vm.value = $event;
      },
      "delete": _vm.emitDeleteEstimate
    }
  })], 1)], 1), _c('activity-card', {
    attrs: {
      "partner": _vm.partner,
      "source": _vm.source,
      "config": {
        comment: true,
        mail: false
      }
    }
  })], 1)], 1) : _c('latest-entries-card-empty'), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isFinishDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.$t('repairEstimate.finish'),
      "subtitle": _vm.$t('repairEstimate.finishSubtitle'),
      "loading": _vm.isFinishLoading,
      "rightLoading": _vm.isFinishLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isFinishDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isFinishDialogActive = $event;
      },
      "rightClick": _vm.onFinishConfirm,
      "leftClick": function leftClick($event) {
        _vm.isFinishDialogActive = false;
      },
      "close": function close($event) {
        _vm.isFinishDialogActive = false;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }